import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Button, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import { loadSingleCenterProduct } from "../../../CenterProductsList/CenterProductsList.slice";
import enableIcon from "@icons/ic-enable.svg";
import disableIcon from "@icons/ic-disable.svg";

import { inputStyles, inputStylesError, errorStyles } from "@utils/extra-style";

import {
  LabelDiv,
  ValueDiv,
  PaddingDiv,
  BoxDiv,
  PollutionSubDiv,
  ButtonWrapper,
  TextInput,
  RequiredMessage,
  StrictLimitInfo,
} from "./PollutionParams.styled";
import "../../CenterProductView.scss";

const AddPollutionParams = (props) => {
  const {
    t,
    polllutions,
    pollutionParam,
    strictLimit,
    editPollutionParam,
    setCenterProductData,
    companyId,
    centerId,
    centerProductId,
  } = props;
  const dispatch = useDispatch();
  const [polllutionData, setPolllutionData] = useState([]);
  const [updateAPIError, setUpdateAPIError] = useState("");
  const [limit, setLimit] = useState(strictLimit);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let tempData = [];
    pollutionParam.map((polllutionPara) => {
      let pollution = "";
      if (polllutions !== null) {
        pollution = polllutions.find(
          (polllution) => polllution.parameterId === polllutionPara.id
        );
      }
      if (pollution) {
        const data = {
          parameterId: polllutionPara.id,
          label: pollution.label,
          value: pollution.value !== null ? pollution.value : "",
          error: "",
        };
        tempData.push(data);
      } else {
        const data = {
          parameterId: polllutionPara.id,
          label: polllutionPara.label,
          value:
            polllutionPara.defaultValue !== null
              ? polllutionPara.defaultValue
              : "",
          error: "",
        };
        tempData.push(data);
      }
    });
    setPolllutionData(tempData);
  }, []);

  const changePollutionValue = (e, id) => {
    const newValue = e.target.value;
    const index = polllutionData.findIndex(
      (polllution) => polllution.parameterId === id
    );
    if (index !== -1) {
      const temporaryarray = polllutionData.slice();
      temporaryarray[index].value = newValue;
      temporaryarray[index].error =
        newValue === "" ? t("POLLUTION_REQUIRED") : "";
      setPolllutionData(temporaryarray);
    }
  };

  const validateForm = (data) => {
    let isFormValid = true;
    const temporaryarray = polllutionData.slice();
    data.map((polllution, index) => {
      if (polllution.value === "") {
        isFormValid = false;
        temporaryarray[index].error = t("POLLUTION_REQUIRED");
      }
      if (polllution.value && !/^-?\d*[.,]?\d{0,2}$/.test(polllution.value)) {
        isFormValid = false;
        temporaryarray[index].error = t("FORMAT_ERROR");
      }
    });
    if (!isFormValid) {
      setPolllutionData(temporaryarray);
    }
    return isFormValid;
  };
  const getFormData = () => {
    let pollutionParam = [];
    polllutionData.map((polllution) => {
      pollutionParam.push({
        parameterId: polllution.parameterId,
        label: polllution.label,
        value: polllution.value,
      });
    });
    const data = {
      strictLimit: limit,
      parameters: pollutionParam,
    };
    return data;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(polllutionData);
    if (isFormValid) {
      setIsLoading(true);
      axios
        .put(
          `/companies/${companyId}/centres/${centerId}/products/${centerProductId}/updatePollutionParameters`,
          getFormData()
        )
        .then((response) => {
          setIsLoading(false);
          dispatch(loadSingleCenterProduct(response.data[0]));
          setCenterProductData(response.data[0]);
          editPollutionParam();
        })
        .catch((error) => {
          setIsLoading(false);
          setUpdateAPIError(error.response?.data?.message ?? "");
        });
    }
  };

  const updateLimit = () => {
    setLimit(limit ? 0 : 1);
  };

  return (
    <PaddingDiv
      padding={strictLimit === 1 ? "2% 7% 30px 7%" : "30px 7% 30px 7%"}
    >
      <StrictLimitInfo>
        <Image
          src={limit ? enableIcon : disableIcon}
          alt={t("STRICT_LIMITS")}
          marginRight="10px"
          onClick={updateLimit}
          className="center-products-view__image-icon"
        />{" "}
        {t("STRICT_LIMITS")}
      </StrictLimitInfo>
      <BoxDiv>
        {polllutionData.length > 0 &&
          polllutionData.map((polllutionPara, index) => {
            return (
              <React.Fragment key={index}>
                <PollutionSubDiv>
                  <LabelDiv border="0px">{polllutionPara.label}</LabelDiv>
                  <ValueDiv border="0px">
                    <TextInput
                      id={"pollution_" + polllutionPara.parameterId}
                      type="text"
                      onChange={(e) =>
                        changePollutionValue(e, polllutionPara.parameterId)
                      }
                      name="pollution_param"
                      value={polllutionPara.value}
                      inputStyles={
                        polllutionPara.error !== ""
                          ? inputStylesError
                          : inputStyles
                      }
                    />
                    {polllutionPara.error && (
                      <RequiredMessage errorStyles={errorStyles}>
                        {polllutionPara.error}
                      </RequiredMessage>
                    )}
                  </ValueDiv>
                </PollutionSubDiv>
              </React.Fragment>
            );
          })}
      </BoxDiv>
      <ButtonWrapper>
        {updateAPIError && <div>{updateAPIError}</div>}
        <Button
          styles={{
            color: "#333",
            background: "#fff",
            border: "1px solid #ccc",
            marginRight: "0.50rem",
            "&:hover": {
              backgroundColor: "#ccc",
            },
          }}
          onClick={editPollutionParam}
        >
          {t("CANCEL")}
        </Button>
        <Button
          styles={{
            color: "white",
            background: "#1BACE4",
            border: "1px solid #1BACE4",
            marginRight: "0.32rem",
            "&:hover": {
              backgroundColor: "#1589b6",
            },
          }}
          onClick={onSubmit}
        >
          <>
            {isLoading && <ClipLoader size={15} color="#fff" />}
            {!isLoading && t("VALIDATE")}
          </>
        </Button>
      </ButtonWrapper>
    </PaddingDiv>
  );
};

AddPollutionParams.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(AddPollutionParams);
